import React from "react";
import FormGrid from "../finalForm/FormGrid";
import {
  PUBLIC_FORM_GRID_COLUMN_GAP,
  PUBLIC_FORM_GRID_ROW_GAP,
} from "./publicFormTokens";

/**
 * FormGrid preset carrying the public forms' spacing, so every step gets the
 * LOS metrics without repeating the two gap props at ~15 call sites (and without
 * one of them quietly drifting).
 *
 * `columns`, `sx` and the rest pass straight through.
 */
const PublicFormGrid = (props) => (
  <FormGrid
    columnGap={PUBLIC_FORM_GRID_COLUMN_GAP}
    rowGap={PUBLIC_FORM_GRID_ROW_GAP}
    {...props}
  />
);

export default PublicFormGrid;
